// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --brand-brightorange: rgba(229, 90, 0, 1);
  --upsell-background: rgba(255, 255, 255, 1);
}

.alert--info {
  background-color: var(--upsell-background);
}

.text-discover-more {
  text-decoration: underline;
  color: var(--brand-brightorange);
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/upsell-feedback/UpsellFeedback.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,eAAe;AACjB","sourcesContent":[":root {\n  --brand-brightorange: rgba(229, 90, 0, 1);\n  --upsell-background: rgba(255, 255, 255, 1);\n}\n\n.alert--info {\n  background-color: var(--upsell-background);\n}\n\n.text-discover-more {\n  text-decoration: underline;\n  color: var(--brand-brightorange);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
